<script>

export default {
   data() {
      return {
         allSlots: []
      }
   },

   props: [
      'recid',
      // 'slots',
      'isTrigger',
      'showMP',
      'activeOrder',
      'isFeed',
      'isGameBlock',
      'saveMe'
   ],

   computed: {
      // orderedSlots() {
      //     let sorted = this.slots.sort(function(a,b) {
      //       let aOrder = parseInt(a.c_order);
      //       let bOrder = parseInt(b.c_order);

      //       // return aDate > bDate;
      //       if(aOrder < bOrder) return -1;
      //       if(aOrder > bOrder) return 1;
      //       return 0;
      //    });
      // }
      orderedSlots() {
         let sorted = [];
         let i = 1;
         while (i <= this.slots.length) {
            let slot = this.slots.filter((s) => {
               return s.order == i;
            });
            sorted[i-1] = slot[0];
            i++;
         }
         return sorted;
      },
   },

   mounted() {
      let self = this;
      this.$nextTick(() => {
        $('tbody').sortable({
           update: function() {
					self.reorderSlots();
			   }
         });
      });
   },

   methods: {
      reorderSlots() {
         let self = this;
         $('tbody').find('.slot-row').each(function(i) {
            self.changeSlotOrder({slotRecid: $(this).attr('recid'), order: ++i});
         });
      }
   }

}
</script>

<style lang="scss" scoped>

#slots_list {
   width: 100%;
   margin-top: 1em;
   margin-bottom: 1em;
   font-size: .85em;

   width: calc(100% + 18px) !important; //hides the default scroll

   .table-row {
      padding-right: 25px;

      &.top {
         border-bottom: 1px solid #354658;
      }
   }

   
}

.row-wrapper {
   .rows {
      max-height: 500px;
      padding-right: 25px;
      width: 100% !important;
      
   }
}

.rows::-webkit-scrollbar {
  display: none;
}

.table-row {
   display: flex;
   justify-content: space-between;

   // &:first-child {
   //    border-bottom: 1px solid #313d4f;
   // }

   .header {
      font-size: 13px;
      font-weight: normal;
      color: #7f8fa4;
      text-align: left;

      padding-bottom: 10px;
   }

   .order {
      // width: 90px;
      width: 50px;
      order: 1;
   } 

   .asset {
      // width: 280px;
      width: 268px;
      order: 2;
   }

   .duration {
      // width: 95px;
      width: 68px;
      order: 3;
   }

   .asset-type {
      // width: 100px;
      width: 72px;
      order: 4;
   }

   .file-type {
      // width: 86px;
      width: 72px;
      order: 5;
   } 

   .status {
      // width: 50px;
      width: 62px;
      order: 6;
   }

   .check {
      // width: 53px;
      width: 65px;
      text-align: center;
   }

   .loop {
      order: 6;
   }

   .hot-pick {
      order: 7;
   }

   .no-ads {
      order: 8;
   }

   .buttons {
      // width: 135px;
      width: 125px;
      order: 9;
   }
}
</style>



